import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { mergeRefs } from '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Flex from '../Flex/index.esm.js';
import '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import { useId } from '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import '../../hooks/use-hints.esm.js';
import { useInputStyle } from '../../hooks/use-input-style.esm.js';
import '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import '../Popper/popper.modifiers.esm.js';
import { usePopper } from '../Popper/use-popper.esm.js';
import '../Popper/use-popper-v2.esm.js';
import Text from '../Text/index.esm.js';
import Label from '../Label/index.esm.js';
import { useCombobox } from 'downshift';
import { format, isMatch, parse } from 'date-fns';
import Grid from '../Grid/index.esm.js';
import DateRangePickerContextProvider from './context.esm.js';
import { getDateWithoutTime } from './utils/index.esm.js';
import PickerCalendar from './components/PickerCalendar.esm.js';

var today = /*#__PURE__*/getDateWithoutTime();
var DateRangePicker = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$id = props.id,
      id = _props$id === void 0 ? "date-range-picker-" + useId() : _props$id,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      label = props.label,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? ['Start date', 'End date'] : _props$placeholder,
      disabled = props.disabled,
      invalid = props.invalid,
      startDate = props.startDate,
      setStartDate = props.setStartDate,
      endDate = props.endDate,
      setEndDate = props.setEndDate,
      _props$formatDate = props.formatDate,
      formatDate = _props$formatDate === void 0 ? props.includeTime === false ? 'yyyy/MM/dd' : 'yyyy/MM/dd HH:mm' : _props$formatDate,
      _props$includeTime = props.includeTime,
      includeTime = _props$includeTime === void 0 ? true : _props$includeTime,
      _props$autoChangeFocu = props.autoChangeFocus,
      autoChangeFocus = _props$autoChangeFocu === void 0 ? true : _props$autoChangeFocu,
      disabledDate = props.disabledDate,
      width = props.width,
      _props$showInput = props.showInput,
      showInput = _props$showInput === void 0 ? true : _props$showInput,
      rest = _objectWithoutPropertiesLoose(props, ["id", "readOnly", "size", "placement", "label", "placeholder", "disabled", "invalid", "startDate", "setStartDate", "endDate", "setEndDate", "formatDate", "includeTime", "autoChangeFocus", "disabledDate", "width", "showInput"]);

  var minWidth = useRef(format(today, formatDate).length);
  var containerRef = useRef(null);

  var _useState = useState('startDate'),
      focus = _useState[0],
      setFocus = _useState[1];

  var _useState2 = useState(startDate ? format(startDate, formatDate) : ''),
      startInput = _useState2[0],
      setStartInput = _useState2[1];

  var _useState3 = useState(endDate ? format(endDate, formatDate) : ''),
      endInput = _useState3[0],
      setEndInput = _useState3[1];

  var _useState4 = useState(today),
      monthYear = _useState4[0],
      setMonthYear = _useState4[1];

  var _useCombobox = useCombobox({
    items: []
  }),
      openMenu = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu,
      isOpen = _useCombobox.isOpen,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps;

  var _usePopper = usePopper({
    forceUpdate: isOpen,
    gutter: 8,
    placement: placement
  }),
      popper = _usePopper.popper,
      reference = _usePopper.reference;

  useEffect(function () {
    setStartInput(startDate ? format(startDate, formatDate) : '');
  }, [startDate]);
  useEffect(function () {
    setEndInput(endDate ? format(endDate, formatDate) : '');
  }, [endDate]);
  var context = {
    open: isOpen,
    closeMenu: closeMenu,
    getMenuProps: getMenuProps,
    size: size,
    popper: popper,
    startDate: startDate,
    setStartDate: setStartDate,
    endDate: endDate,
    setEndDate: setEndDate,
    focus: focus,
    setFocus: setFocus,
    monthYear: monthYear,
    setMonthYear: setMonthYear,
    includeTime: includeTime,
    autoChangeFocus: autoChangeFocus,
    disabledDate: disabledDate,
    today: today
  };
  var inputStyle = useInputStyle({
    block: true,
    type: 'text',
    size: size,
    disabled: disabled,
    invalid: invalid,
    readOnly: readOnly
  });
  return React__default.createElement(DateRangePickerContextProvider, {
    value: context
  }, React__default.createElement(Box, {
    ref: mergeRefs(reference.ref, containerRef),
    position: "relative",
    style: width ? undefined : {
      width: size === 'sm' ? 350 : 450,
      minWidth: minWidth.current / 5 * 11 + "ch"
    },
    width: width
  }, React__default.createElement(Label, {
    visuallyHidden: true,
    htmlFor: id
  }, label != null ? label : placeholder), showInput ? React__default.createElement(Grid, _extends({}, getComboboxProps(), {
    gridTemplateColumns: "grid-cols-11"
  }), React__default.createElement(Box, _extends({
    ref: ref,
    as: "input",
    dangerouslySetClassName: "form-input",
    placeholder: placeholder[0],
    gridColumn: "col-span-5"
  }, inputStyle, {
    boxShadow: isOpen && focus === 'startDate' ? 'shadow-outline-blue' : undefined,
    borderColor: isOpen && focus === 'startDate' ? 'border-blue-300' : inputStyle.borderColor
  }, getInputProps({
    value: startInput,
    onChange: function onChange(e) {
      var value = e.currentTarget.value;
      setStartInput(value);

      if (value.length === formatDate.length && isMatch(value, formatDate)) {
        setStartDate(parse(value, formatDate, today));
      }
    },
    onBlur: function onBlur(e) {
      var value = e.currentTarget.value;

      if (!value) {
        setStartDate(null);
      } else if (value.length !== formatDate.length || !isMatch(value, formatDate)) {
        setStartInput(startDate ? format(startDate, formatDate) : '');
      } else if (endDate && parse(value, formatDate, today).getTime() > endDate.getTime()) {
        setStartDate(null);
      } else if (disabledDate && startDate && disabledDate(startDate)) {
        setStartDate(null);
      }
    },
    onFocus: function onFocus() {
      setFocus('startDate');

      if (startDate) {
        setMonthYear(getDateWithoutTime(startDate));
      }

      if (!isOpen) {
        openMenu();
      }
    }
  }), rest)), React__default.createElement(Flex, {
    width: "w-full",
    height: "h-full",
    justifyContent: "justify-center",
    alignItems: "items-center"
  }, React__default.createElement(Box, {
    userSelect: "select-none",
    fontSize: size === 'sm' ? 'text-sm' : 'text-base'
  }, "\u2013")), React__default.createElement(Box, _extends({
    as: "input",
    dangerouslySetClassName: "form-input",
    placeholder: placeholder[1],
    gridColumn: "col-span-5"
  }, inputStyle, {
    boxShadow: isOpen && focus === 'endDate' ? 'shadow-outline-blue' : undefined,
    borderColor: isOpen && focus === 'endDate' ? 'border-blue-300' : inputStyle.borderColor
  }, getInputProps({
    value: endInput,
    onChange: function onChange(e) {
      var newValue = e.currentTarget.value;
      setEndInput(newValue);

      if (newValue.length === formatDate.length && isMatch(newValue, formatDate)) {
        setEndDate(parse(newValue, formatDate, today));
      }
    },
    onBlur: function onBlur(e) {
      var value = e.currentTarget.value;

      if (!value) {
        setEndDate(null);
      } else if (value.length !== formatDate.length || !isMatch(value, formatDate)) {
        setEndInput(endDate ? format(endDate, formatDate) : '');
      } else if (startDate && parse(value, formatDate, today).getTime() < startDate.getTime()) {
        setEndDate(null);
      } else if (disabledDate && endDate && disabledDate(endDate)) {
        setEndDate(null);
      }
    },
    onFocus: function onFocus() {
      setFocus('endDate');

      if (endDate) {
        setMonthYear(getDateWithoutTime(endDate));
      }

      if (!isOpen) {
        openMenu();
      }
    }
  }), rest))) : React__default.createElement(Grid, _extends({}, getComboboxProps()), React__default.createElement(Grid, _extends({
    ref: ref,
    as: "button",
    dangerouslySetClassName: "form-input",
    placeholder: placeholder[0],
    boxShadow: isOpen ? 'shadow-outline-blue' : undefined,
    borderColor: isOpen ? 'border-blue-300' : 'border-gray-200',
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    gridTemplateColumns: "grid-cols-11"
  }, getInputProps({
    onFocus: function onFocus() {
      if (!isOpen) {
        openMenu();
      }
    }
  }), rest), React__default.createElement(Text, {
    gridColumn: "col-span-5",
    textColor: !startDate ? 'text-gray-400' : undefined
  }, startDate ? format(startDate, formatDate) : placeholder[0]), React__default.createElement(Text, null, "\u2013"), React__default.createElement(Text, {
    gridColumn: "col-span-5",
    textColor: !endDate ? 'text-gray-400' : undefined
  }, endDate ? format(endDate, formatDate) : placeholder[1]))), React__default.createElement(PickerCalendar, null)));
});

if (__DEV__) {
  DateRangePicker.displayName = 'DateRangePicker';
}

export default DateRangePicker;
//# sourceMappingURL=index.esm.js.map
